import { Input } from "../ui/input";
import { Label } from "../ui/label";

export const CONTACT_FIELDS = [
  { key: "name", label: "Full name", type: "text", autoComplete: "name" },
  { key: "email", label: "Email", type: "email", autoComplete: "email", inputMode: "email" },
  { key: "phone", label: "Phone", type: "tel", autoComplete: "tel", inputMode: "tel" },
  { key: "company", label: "Company or agency", type: "text", autoComplete: "organization" },
  { key: "job_title", label: "Job title", type: "text", autoComplete: "organization-title" },
];

export const EMPTY_CONTACT = { name: "", email: "", phone: "", company: "", job_title: "" };

// Shared contact field set — used by card review, manual add, kiosk and QR sign-up.
export const ContactFields = ({ value, onChange, testidPrefix, required = [], large = false }) => (
  <div className="space-y-3">
    {CONTACT_FIELDS.map((f) => (
      <div key={f.key} className="space-y-1">
        <Label htmlFor={`${testidPrefix}-${f.key}`} className="text-[11px] font-bold uppercase tracking-[0.12em] text-brand-charcoal/65">
          {f.label}{required.includes(f.key) && <span className="text-brand-gold-dark"> *</span>}
        </Label>
        <Input
          id={`${testidPrefix}-${f.key}`}
          data-testid={`${testidPrefix}-${f.key}`}
          type={f.type}
          inputMode={f.inputMode}
          autoComplete={f.autoComplete}
          required={required.includes(f.key)}
          value={value[f.key] || ""}
          onChange={(e) => onChange({ ...value, [f.key]: e.target.value })}
          className={`rounded-xl bg-white border-black/10 ${large ? "h-14 text-[17px]" : "h-12 text-[16px]"}`}
        />
      </div>
    ))}
  </div>
);

export default ContactFields;
